import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/nf1图标-4.png'
import _imports_1 from '../assets/nf1图标-3.png'
import _imports_2 from '../assets/nf1图标-1.png'
import _imports_3 from '../assets/nf1图标-2.png'


const _hoisted_1 = { class: "lk-portal-nf1-login" }
const _hoisted_2 = { class: "lk-portal-nf1-login-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"lk-portal-nf1-login-content-main-logo-anchor\"><div class=\"lk-portal-nf1-login-content-main-logo\"><img class=\"main-logo-image\" src=\"" + _imports_0 + "\" alt=\"NICE logo\"></div></div><div class=\"lk-portal-nf1-login-content-anchor\"><div class=\"lk-portal-nf1-login-content-partner-logos\"><img class=\"logo-item logo-item-institute\" src=\"" + _imports_1 + "\" alt=\"institute logo\"><img class=\"logo-item logo-item-badge\" src=\"" + _imports_2 + "\" alt=\"hospital logo\"><img class=\"logo-item logo-item-badge1\" src=\"" + _imports_3 + "\" alt=\"NF1 logo\"></div></div><div class=\"lk-portal-nf1-login-content-title\"><p>Leading NF1 Research in China/引领中国NF1研究</p><h3>中国神经纤维瘤病临床流行病学队列</h3><h3>China NICE Cohort</h3><p>The China Neurofibromatosis Integrated Clinical and Epidemiological Cohort</p></div>", 3)
const _hoisted_6 = { class: "lk-portal-nf1-login-container" }
const _hoisted_7 = { class: "lk-portal-nf1-login-content-login-modal" }
const _hoisted_8 = {
  key: 0,
  class: "embed-logo"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "embed-wrapper" }
const _hoisted_11 = { class: "lk-portal-nf1-login-container" }
const _hoisted_12 = { class: "lk-portal-nf1-login-footer" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "上海整形医学产业创新研究院是上海市批准成立的新型非营利性社会组织。上海整形医学产业创新研究院致力于集聚全球整形医学产学研资源，构建多学科跨界产业创新平台，打造整形医学产业创新发展生态链，促进我国整形医学产业自主创新发展和国际竞争能力，提升我国整形医学发展水平和整形医学产业对社会经济发展的促进作用。", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "上海整形医学产业创新研究院", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBox = _resolveComponent("LoginBox")!
  const _component_PrivateLogin = _resolveComponent("PrivateLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          (_ctx.showLinkdocText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.state.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "logo",
                      src: _ctx.state.logo,
                      alt: "logo"
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'embed-passport-login': true, 'private-passport-login': _ctx.state.isInHospEnv && _ctx.isNuc }),
              id: "embed-passport-login"
            }, [
              (_ctx.state.isInHospEnv && _ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_LoginBox, {
                    key: 0,
                    loginBoxOutStyle: false,
                    showForget: ""
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.isInHospEnv && !_ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_PrivateLogin, { key: 1 }))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ], 512), [
          [_vShow, _ctx.state.logo]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("footer", _hoisted_12, [
        (_ctx.state.isInHospEnv)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "在使用本产品的过程中请严格遵守医院的个人信息处理规则!"))
          : _createCommentVNode("", true),
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("p", null, "零氪科技提供技术支持 @" + _toDisplayString(_ctx.currentYear) + " LinkDoc 京ICP备15001843号-1", 1)
      ])
    ])
  ]))
}